<template>
  <component
    :is="varComp"
    :hover="hovering"
    variant=""
    :resource="resource"
    :imageInfo="imageInfo"
  ></component>
</template>

<script>
import ImageFull from './ImageFull';
import ImageThumb from './ImageThumb';
import ImageListItem from './ImageListItem';

export default {
  components: { ImageFull, ImageListItem, ImageThumb },
  props: {
    hovering: {},
    blockData: {
      default: () => ({
        resource: {},
        excerpts: []
      })
    },
    blockType: {},
    variant: {}
  },
  data() {
    return {
      comps: {
        full: ImageFull,
        listItem: ImageListItem,
        thumb: ImageThumb
      }
    };
  },
  computed: {
    varComp() {
      return this.comps[this.variant];
    },
    resource() {
      return this.blockData.resource;
    },
    imageInfo() {
      return this.blockData.resource ? this.blockData.resource.resourceData : {};
    }
  }
};
</script>
